jQuery(document).ready(function($){ 

	var svg = $("svg#osiedle > *:not(image)");
	
	var jsonString = 'https://osadawojcieszyce.pl/wp-json/wp/v2/dzialki?per_page=66';
	// var jsonString = 'https://localhost/wojcieszyce/wp-json/wp/v2/dzialki?per_page=66';
	// var jsonString = 'https://wojcieszyce.bear.098.pl/wp-json/wp/v2/dzialki?per_page=66';

	var $card = $('#tooltip');

	let houses = [];

	$.getJSON(jsonString, function(data){		
		$.grep( data, function( n, i ) {
			$('#x' +  n.slug ).addClass(n.acf.status);
			houses.push(n);
		});
  	});	

	svg.on("mouseenter touchstart", function(e) {
		var title = $(this).attr('id');
		$card.removeClass('open');

		var result = houses.find(obj => {
		  return obj.title.rendered == title.substring(1);
		});

		if ( result){

			$('.tooltipCard__title').html( 'Działka ' + result.title.rendered );
			$('.tooltipCard__value.status').html(result.acf.status); 
			$('.tooltipCard__item.cena_prom').hide();

			if (result.acf.status != "Dostępna"){
				$('.tooltipCard__item.metraz').hide();
				$('.tooltipCard__item.cena').hide();
				$('.tooltipCard__item.reserve').hide();
			} else {
				$('.tooltipCard__item.metraz').show();
				$('.tooltipCard__item.cena').show();
				$('.tooltipCard__item.reserve').show();
				$('.tooltipCard__item.cena .tooltipCard__sublabel').show();
				$('.tooltipCard__value.cena').removeClass('old');

				$('.tooltipCard__value.metraz').html(result.acf.metraz + " m<sup>2</sup>");
				$('.tooltipCard__value.cena').html( numberWithSpaces(result.acf.cena) + " zł");

				// console.log(result.acf.promocja);
				
				if (result.acf.promocja != false){
					$('.tooltipCard__value.cena_prom').html( numberWithSpaces(result.acf.cena_promocyjna) + " zł");
					$('.tooltipCard__value.cena').addClass('old');
					$('.tooltipCard__item.cena .tooltipCard__sublabel').hide();
					$('.tooltipCard__item.cena_prom').show();
				} 		
			}

			$card.addClass('open');	
  		}
  			  	
	});

	svg.on("mousemove", function(e) {

		if (!mobileCheck()){
			var x = (e.clientX);
			var y = (e.clientY);
			$card.css('left', x + 12  )
				 .css('top', y + 12 );
		}
	});


	svg.on("mouseout", function(e) {
		if (!mobileCheck()){
			$card.removeClass('open');
		}
	});

	window.mobileCheck = function() {
	  let check = false;
	  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	  return check;
	};

	function numberWithSpaces(x) {
	    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	}

	// var wpcf7Elm1 = document.getElementsByClassName( 'wpcf7' )[0];
	var wpcf7Elm1 = document.getElementById( 'wpcf7-f8595-p8833-o2' );

	if ( wpcf7Elm1 ){ wpcf7Elm1.addEventListener( 'wpcf7mailsent', afterSend, false ); }
	// if ( wpcf7Elm2 ){ wpcf7Elm2.addEventListener( 'wpcf7mailsent', afterSend, false ); }

	function afterSend(event) {
	    
		$('#modalHeader').hide();
		$('.modal__data').hide();
		$('.modal__form').hide();
		$('.modal__info').hide();
		$('.modal__success').css('display', 'flex');
		$('.reveal').css('width', '480px');
	}

	svg.on('click tap', function(e){
		
		if ( !$(this).hasClass('Dostępna') ){
			e.preventDefault();
			return;
		} else {
			openModal($(this));
			if (!mobileCheck()){
				$('#infoReserve').click();
			}
		}
	});
	
	$('.estateTable__button').on('click', function(){
		openModal($(this));
	});
	
	$(document).on('afterClose.fb', function( e, instance, slide ) {
		$('#modalHeader').show();
		$('.modal__form').show();
		$('.modal__data').show();
		$('.modal__success').hide();
		$('.reveal').css('width', '980px');	
	});

	function openModal(thisObj) {
		var lokal = thisObj.attr('id').substring(1);
		// console.log(lokal); 
		$('#lokal').val(lokal);
		$('#modalHeader').html('Działka ' + lokal);

		var result = houses.find(obj => {
			return obj.title.rendered == lokal;
		});
  
		if ( result){
			$('#plotNumber').html(result.title.rendered);
			$('.modal__data__value.status').html(result.acf.status);
			$('.modal__data__value.powierzchnia').html(result.acf.metraz + ' m<sup>2</sup>');
			$('.modal__data__value.cena').html( numberWithSpaces(result.acf.cena) + " zł" );
			$('#plotButton').attr('href', result.acf.karta_dzialki);
		}
	}

});